import Attrs from '../models/Attrs'
import type { Component } from '../models/types'
import renderTemplate from '../helpers/templating'
import { addLanguageController } from '../helpers/utils'

const CONTROLLER = 'components--rich-text-markdown'
export default function renderRichTextMarkdown(
  component: Component,
  attrs: Attrs,
  userData: { [key: string]: unknown }
): string {
  attrs
    .addController(CONTROLLER)
    .addAction(`${CONTROLLER}:update->flow#batchUpdate`, `${CONTROLLER}:info-box->flow#openInfoBox`)

  //* Add template controller if the text has {{
  if (component.text && component.text.includes('{{')) {
    attrs.addController('template')
    attrs.addValueIfExists('template', 'text', encodeURIComponent(component.text || ''))
    attrs.addValueIfExists('template', 'always-rerender', component.always_rerender)
  }

  const textAttrs = new Attrs(attrs.static_render)

  //* Add language controller for the text
  addLanguageController({ attrs: textAttrs, component, keys: ['text'] })

  const text = renderTemplate(component.text, userData)
  return `<div ${attrs}><div ${textAttrs}>${text}</div></div>`
}
